<template>
<div class="specialGroupDialog ">
    <el-dialog :title="type==1?'新增组别':'新增配置'" :visible.sync="dialogVisible" width="908px" :close-on-click-modal="false">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm form">
            <div class="flexstart project-setting">
                <el-form-item label="" prop="name" v-if="type==2">
                    行首名称&nbsp;&nbsp;<el-input v-model.trim="item.name" placeholder="建议2个字" clearable></el-input>
                </el-form-item>
                <el-form-item label="" prop="linkurl" v-if="type==2">
                    行首链接&nbsp;&nbsp;<el-input v-model.trim="item.linkurl" placeholder="" clearable></el-input>
                </el-form-item>
            </div>
            <el-table :data="item.content" style="width: 100%" :show-header="false" ref="multipleTable">
                <el-table-column label="标题内容" width="320px">
                    <template slot-scope="scope">
                        <el-form-item label="" :prop="'content.'+ scope.$index + '.name'" :rules='rules.name'>
                            <el-input v-model.trim="scope.row.name" placeholder="请输入标题内容，建议不要过长" clearable maxlength="50"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="链接类型">
                    <template slot-scope="scope">
                        <el-radio-group v-model="scope.row.contenttype">
                            <el-radio :label="1">自有内容</el-radio>
                            <el-radio :label="2">第三方内容</el-radio>
                        </el-radio-group>
                        <el-form-item label="" class="linktype" :prop="'content.'+ scope.$index + '.contentinnerid'" :rules='scope.row.contenttype==1 ? rules.contentinnerid : {}' v-if="scope.row.contenttype==1">
                            <div class="flexstart">
                                <el-button type="primary" plain @click="handleOpen(scope.row, scope.$index)">选择内容</el-button>
                                <div class="text-ellipse selectContent" v-if="scope.row.contentinnerid">{{scope.row.contentname}}</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" class="linktype" :prop="'content.'+ scope.$index + '.linkurl'" :rules='scope.row.contenttype==2 ? rules.linkurl : {}' v-if="scope.row.contenttype==2">
                            <el-input v-model.trim="scope.row.linkurl" placeholder="请填写url"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="排序" class-name="tc" label-class-name="tc" width="80px">
                    <template slot-scope="scope">
                        <div class="upordown">
                            <div class="icon_bb_arrow" :class="[scope.$index==0?'prohibit':'']">
                                <i @click.stop="handleUp(scope.row, scope.$index)" class="icon icon_bb_arrow_up"></i>
                            </div>
                            <div class="icon_bb_arrow" :class="[scope.$index==(item.content.length-1)?'prohibit':'']">
                                <i @click.stop="handleDown(scope.row, scope.$index)" class="icon icon_bb_arrow_down"></i>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80px" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <span class="separator-btn">
                                <el-button @click.stop="handleDel(scope.$index)" type="text" size="small">删除</el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div class="add-but" @click="handleAdd">新增一行</div>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {uploadQuestionbanktopicsection, uploadQuestionbanktopicsectiontask, getQuestionbanktopicsection, getQuestionbanktopicsectiontask} from 'api/questionApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'specialGroupDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                content: [
                    // {
                    //     contentinnerid: '',
                    //     contentname: '',
                    //     contenttype: 1,
                    //     innerid: '',
                    //     linkurl: '',
                    //     name: ''
                    // }
                ],
                examcode: this.$route.query.examcode ? this.$route.query.examcode : '',
                innerid: '',
                linkurl: '',
                name: '',
                sectionid: '',
            },
            param: {
                examcode: this.$route.query.examcode ? this.$route.query.examcode : '',
                innerid: '',
                sectionid: '',
            },
            rules: {
                // name: [
                //     {required: true, message: '请输入标题内容', trigger: 'blur'}
                // ],
                // linkurl: [
                //     {required: true, message: '请输入连接', trigger: 'blur'}
                // ],
                contentinnerid: [
                    {required: true, message: '请选择内容', trigger: 'blur'}
                ],
            },
            selectIndex: '',
            type: 1 // 1组别 2 配置
        }
    },
    mounted() {
    },
    methods: {
        setContentinnerid(selectResult) {
            this.item.content[this.selectIndex].contentinnerid = selectResult.contentinnerid
            this.item.content[this.selectIndex].contentname = selectResult.contentname
        },
        handleOpen(row, index) {
            this.selectIndex = index
            let obj = {
                contentinnerid: row.contentinnerid,
                contentname: row.contentname
            }
            this.$emit('openSpecialListDialog', obj)
        },
        handleAdd() {
            this.item.content.push({
                contentinnerid: '',
                contentname: '',
                contenttype: 1,
                innerid: '',
                linkurl: '',
                name: ''
            })
        },
        handleDel(index) {
            this.item.content.splice(index, 1)
        },
        handleUp(obj, index) {
            this.item.content.splice(index, 1)
            this.item.content.splice(index - 1, 0, obj)
        },
        handleDown(obj, index) {
            this.item.content.splice(index, 1)
            this.item.content.splice(index + 1, 0, obj)
        },
        openDialog(type, selectRow) {
            this.type = type
            if (this.type == 2) {
                this.param.innerid = selectRow.innerid
                this.param.sectionid = selectRow.sectionid
                if (this.param.innerid) {
                    this._getProjectView()
                } else {
                    this.item.innerid = this.param.innerid
                    this.item.sectionid = this.param.sectionid
                    this.item.examcode = this.param.examcode
                    this.handleAdd()
                }
            } else {
                this.param.innerid = selectRow.innerid
                this.param.sectionid = ''
                if (this.param.innerid) {
                    this._getGroupView()
                } else {
                    this.item.innerid = this.param.innerid
                    this.item.sectionid = this.param.sectionid
                    this.item.examcode = this.param.examcode
                    this.handleAdd()
                }
            }
            this.dialogVisible = true
        },
        cancel() {
            this.$refs.ruleForm.clearValidate()
            this.item = {
                content: [],
                examcode: this.$route.query.examcode ? this.$route.query.examcode : '',
                innerid: '',
                linkurl: '',
                name: '',
                sectionid: '',
            }
            this.selectIndex = []
            this.dialogVisible = false
        },
        submit() {
            if (!this.item.content.length) {
                this.$message.error(`请添加${this.type==1?'组别':'配置'}`)
                return false
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this._saveGroup()
                    } else {
                        this._saveProject()
                    }
                }
            })
        },
        _saveGroup() {
            this.setLoading(true)
            uploadQuestionbanktopicsection({
                data: Object.assign({}, this.item),
                success: () => {
                    this.setLoading(false)
                    this.$emit('refresh', this.type)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _saveProject() {
            this.setLoading(true)
            uploadQuestionbanktopicsectiontask({
                data: Object.assign({}, this.item),
                success: () => {
                    this.setLoading(false)
                    this.$emit('refresh', this.type)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getGroupView() {
            this.setLoading(true)
            getQuestionbanktopicsection({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.examcode = this.param.examcode
                    data.data.innerid = this.param.innerid
                    this.item= data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getProjectView() {
            this.setLoading(true)
            getQuestionbanktopicsectiontask({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.examcode = this.param.examcode
                    data.data.innerid = this.param.innerid
                    data.data.sectionid = this.param.sectionid
                    this.item= data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
.specialGroupDialog {
    .form{
        margin: 0;
    }
    .el-radio-group{
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
    .linktype{
        .el-button{
            margin: 0;
            width: 120px;
            height: 32px;
            line-height: 32px;
            margin-right: 8px;
        }
        .selectContent{
            height: 32px;
            padding: 0 12px;
            line-height: 32px;
            background: #E5E5E5;
            border-radius: 4px;
            border: 1px solid #D8DCE6;
        }
    }
    .el-input{
        line-height: 1;
    }
    .el-form-item__content{
    }
    .form-footer{
        display: flex;
        justify-content: center;
    }
    .add-but{
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409EFF;
        font-size: 14px;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px #DCDFE6;

    }
    .el-button{
        margin-bottom: 0;
    }
    .project-setting{
        .el-form-item{
            flex-grow: 1;
        }
        .el-form-item+.el-form-item{
            margin-left: 20px;
        }
        .el-form-item__content{
            display: flex;
            align-items: center;
            white-space: nowrap
        }
    }
}
</style>
